.aw{max-width:100%;}